import { Checkbox, ListItem, ListItemIcon, ListItemText } from '@mui/material'
import React from 'react'

export interface CannedJobPartData {
  id: string
  name: string
  quantity?: number | undefined
  secondaryText?: string
}

export const CustomListItem = ({
  data,
  handleClick,
  checked,
  disableSelectSubItem,
  id
}: {
  data: CannedJobPartData
  handleClick: (newStatus: boolean, partId: string) => void
  checked: boolean
  disableSelectSubItem?: boolean
  id: string
}) => {
  return (
    <ListItem disableGutters disablePadding>
      {!disableSelectSubItem && (
        <ListItemIcon sx={{ minWidth: '36px' }}>
          <Checkbox
            size="small"
            edge="start"
            checked={checked}
            disableRipple
            onClick={(e) => e.stopPropagation()}
            onChange={(event, newStatus) => {
              event.stopPropagation()
              handleClick(newStatus, data.id)
            }}
            sx={{ py: 0 }}
            id={id}
          />
        </ListItemIcon>
      )}
      <ListItemText
        primary={
          (data.quantity ? '(' + data.quantity + ') x ' : '') + data.name!
        }
        secondary={data.secondaryText}
      />
    </ListItem>
  )
}
